<template>
  <v-row dense>
    <p>
      <MarkTag :text="printContent" :match="getQuery" />
    </p>
    <ClientFiler v-if="hasAttachments"
      :items="getAttachments"
      :showOnlyItems="true"
      :selectable="false"
    />
  </v-row>
</template>
<script>
import MarkTag from '@/components/tags/mark'
import ClientFiler from '@/components/filers/client'
export default {
  name: 'postRecordLayout',
  props: [ 'item' ],
  components: {
    MarkTag,
    ClientFiler,
  },
  computed: {
    printContent () {
      const { content } = this.$props.item
      return content ? content.replace(/\n/g, '<br />') : ''
    },
    hasAttachments () {
      return this.$props.item && this.$props.item.attachments && this.$props.item.attachments.length
    },
    getQuery () {
      return this.$route.query && this.$route.query.query
    },
    getAttachments () {
      return (
        this.$props.item &&
        this.$props.item.attachments &&
        this.$props.item.attachments.length
      ) ? this.$props.item.attachments : []
    }
  }
}
</script>